export enum ClientType {
    WEBGL = 'webgl',
    EMSCRIPTEN = 'emscripten'
}
